import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { PricingFormatter, FullPriceFormatter } from 'helpers/formatters';

import TextEntry from '@arrive/text-entry';

import { OFFERS_INPUT_MAX, OFFERS_INPUT_MIN } from 'constants/offerConstants';

import styles from './BookingModal.scss';

interface Props {
  setOfferAmount: (a: string) => void;
  offerAmount: string;
  topSpend: number;
  miles: number;
}
const BookingModalOffer = ({ offerAmount, setOfferAmount, miles, topSpend }: Props) => {

  const [isInputFocused, setInputFocused] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    if (!isInputFocused && Number(offerAmount) <= topSpend) {
      setShowErrorMessage(true);
    } else {
      setShowErrorMessage(false);
    }
  }, [isInputFocused, offerAmount, topSpend]);

  useEffect(() => {
    const errorMessageTimeout = setTimeout(() => {
      if (Number(offerAmount) <= topSpend) {
        setShowErrorMessage(true)
      }
    }, 1500)

    return () => clearTimeout(errorMessageTimeout)
  }, [offerAmount, topSpend])

  const handleInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = Number(evt.target.value);
    if (!Number.isNaN(nextValue) && nextValue >= OFFERS_INPUT_MIN && nextValue <= OFFERS_INPUT_MAX) {
      setOfferAmount(evt.target.value);
    }
  }

  const ratePerMile = Number(offerAmount) / miles;
  return (
    <div className={styles.listContent}>
      <div className={styles.header}>Your offer amount.</div>
      <div className={styles.subHeader}>Because this load is picking up today, we need to confirm some information.</div>
      <div className={styles.offerContainer}>
        <TextEntry
          classes={{ inputWrapper: styles.offerEntry }}
          label={'Offer Amount'}
          onChange={handleInputChange}
          value={isInputFocused ? offerAmount : PricingFormatter.format(Number(offerAmount))}
          entrySize='lg'
          theme='ethanol'
          type={isInputFocused ? 'number' : 'text'}
          onFocus={() => setInputFocused(true)}
          onBlur={() => setInputFocused(false)}
          onWheel={(evt: React.WheelEvent<HTMLInputElement>) => evt.stopPropagation()}
          onKeyDown={(evt: React.KeyboardEvent<HTMLInputElement>) => {
            if(evt.key==='.'){
              evt.preventDefault();
            }
          }}
          aria-label={`Offer Amount - Must be greater than ${topSpend}`}
          max={OFFERS_INPUT_MAX}
          min={OFFERS_INPUT_MIN}
        />
        {!showErrorMessage && <div className={cx(styles.ratePerMile, !miles && styles.placeholderRPM)}>{miles ? `Rate Per Mile ${FullPriceFormatter.format(ratePerMile)}/mi` : ''}</div>}
        {showErrorMessage && <div className={styles.bookingErrorMessage}>Offer must be more than {PricingFormatter.format(topSpend)}</div>}
      </div>
    </div>
  );
};

export default BookingModalOffer;
